module.exports = __webpack_public_path__ + "static/img/s129.702b8a75.png";